import { useTranslation } from 'react-i18next';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

function PickupPointsTable({ pickupPoints }) {
  const { t } = useTranslation(['table']);

  if (!pickupPoints?.length) {
    return null;
  }

  return (
    <TableContainer sx={{ my: 2 }}>
      <Table size="small" sx={{ fontSize: { xs: 13, sm: 14 } }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 600, fontSize: { xs: 13, sm: 14 } }}>
              {t('routes.enabled.pickup_point', { ns: 'table' })}
            </TableCell>
            <TableCell sx={{ fontWeight: 600, fontSize: { xs: 13, sm: 14 } }}>
              {t('routes.enabled.city_name', { ns: 'table' })}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {pickupPoints.map((point) => (
            <TableRow key={point.id_warecloud}>
              <TableCell sx={{ fontSize: { xs: 13, sm: 14 } }}>
                {point.id_warecloud}
              </TableCell>
              <TableCell sx={{ fontSize: { xs: 13, sm: 14 } }}>
                {point.city_name}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

export default PickupPointsTable;
